import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import NoticeProductListContainer from '../../../containers/notice/NoticeProductListContainer';
import { NOTICE_PRODUCT_PAGE_NAME } from '../../../constants/service/app/noticeProductConstants';

const NoticeProductList = () => {
  return (
    <PageTemplate pageName={NOTICE_PRODUCT_PAGE_NAME.LIST}>
      <NoticeProductListContainer />
    </PageTemplate>
  );
};

export default NoticeProductList;
